import { SVGProps } from '@components/Icon/types';

export const Busket = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(1.56, 1.9)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4351 0C13.8708 0.000256551 15.0347 1.16383 15.0347 2.59961V4H18.27C19.7868 4.00026 20.9818 5.29356 20.8618 6.80566L20.0679 16.8057C19.9604 18.1572 18.8319 19.199 17.4761 19.1992H3.39406C2.03803 19.1992 0.909752 18.1574 0.802259 16.8057L0.00831403 6.80566C-0.111708 5.29339 1.08308 4 2.60011 4H5.83546V2.59961C5.83546 1.16367 6.99913 0 8.43507 0H12.4351ZM2.60011 5.19922C1.78338 5.19922 1.14022 5.89583 1.2046 6.70996L1.99855 16.71C2.05634 17.4379 2.66382 18 3.39406 18H17.4761C18.2061 17.9998 18.8138 17.4378 18.8716 16.71L19.6655 6.70996C19.7299 5.896 19.0865 5.19948 18.27 5.19922H15.0347V7.59961C15.0347 7.93082 14.7662 8.19896 14.4351 8.19922C14.1037 8.19922 13.8355 7.93098 13.8355 7.59961V5.19922H7.03468V7.59961C7.03468 7.93082 6.76622 8.19896 6.43507 8.19922C6.1037 8.19922 5.83546 7.93098 5.83546 7.59961V5.19922H2.60011ZM8.43507 1.19922C7.66187 1.19922 7.03468 1.82641 7.03468 2.59961V4H13.8355V2.59961C13.8355 1.82657 13.2081 1.19948 12.4351 1.19922H8.43507Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'busket';
